<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline">
                    <input v-model="search.code"
                           class="form-control mr-sm-2"
                           type="search"
                           placeholder="รหัสสินค้า"
                           aria-label="Search"
                    /> &nbsp
                    <select class="form-control" v-model="search.type">
                        <option v-for="options in productType"
                                :value="options.value">
                            {{ options.text }}
                        </option>
                    </select> &nbsp
                    <date-picker v-model="search.date"
                                 range
                                 placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                 :format="changeFormat"
                                 :lang="lang" confirm>
                    </date-picker>
                    &nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchOverview"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                </form>
            </div>
        </nav>
        <div style="padding-right: 10px; color: red">**รายงานการจองจะแสดงการจองของวันปัจจุบัน กรุณาเลือกวันที่เพื่อดูรายงานการจองของแต่ละวัน</div>
        <div class="col-sm-12 center table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวน</th>
                    <th scope="col" v-if="user.id == 36">order_id</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in reservation">
                    <td>{{++index}}</td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.sku}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{data.product.name}}
                        </template>
                        <template v-else>
                            <p>-</p>
                        </template>
                    </td>
                    <td>{{data.total | amount}}</td>
                    <td v-if="user.id == 36">
                        {{data.order_id}}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="reservation.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getOverView(dataPaginate.current_page)">
            </vue-pagination>
        </div>
        <br />
<!--        <pre class="alert alert-primary">{{ reservation }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import Table from "bootstrap-vue/src/components/table/table";
    import VuePagination from "../Pagination";
    import DatePicker from 'vue2-datepicker'
    import moment from 'moment';
    export default {
        components: {
            VuePagination,
            DatePicker,
            Table},
        name: "reservations-table",
        data(){
          return {
              reservation : [],
              page : 1,
              search : {
                  date : [] ,
                  code :"",
                  type : "",
              },
              event_submit : false,
              dataPaginate: {
                  current_page: 1,
                  from: 1,
                  last_page: 1,
                  per_page: 1,
                  total: 1,
                  to: 1
              },
              changeFormat: {
                  stringify: (date) => {
                      let date_moment = moment(date).format('YYYY');
                      const year = parseInt(date_moment) + 543;
                      console.log(moment(date).format('DD/MM/'+year));
                      return date ? moment(date).format('DD/MM/'+year) : null
                  },
                  parse: (value) => {
                      return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                  }
              },
              lang: {
                  days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                  months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                  pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                  placeholder: {
                      date: 'วว/ดด/ปปปป',
                  }
              },
          }
        },
        created(){
            this.$store.dispatch('ProductType/get');
            this.getOverView();
        },
        computed:{
            ...mapState({
                productType:state=>{
                    return [
                        {
                            value: "",
                            text: "ประเภทสินค้า"
                        },
                        ...state.ProductType.data.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
                user : state=>{
                    return state.Auth.user;
                },
            })
        },
        methods:{
            getOverView(page){
                this.page = page;
                let data = {
                    start_date : moment(this.search.date[0]).format('YYYY-MM-DD'),
                    end_date : moment(this.search.date[1]).format('YYYY-MM-DD'),
                    product_sku : this.search.code,
                    product_type_id : this.search.type,
                }
                this.$store.dispatch('ProductOverview/get', {
                    page : this.page,
                    data : data
                }).then(res=>{
                        this.reservation = res.data
                        this.dataPaginate = {
                            current_page: res.current_page,
                            from: res.from,
                            last_page: res.last_page,
                            per_page: res.per_page,
                            total: res.total,
                            to: res.to
                        }
                    });
            },
            searchOverview(){
                if(this.search.date.length < 1){
                    alert("กรุณาเลือกช่วงวันที่");
                }else{
                    this.getOverView(1);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .center {
        margin: auto;
        width: 100%;
        padding: 10px;
    }
    /*td:nth-of-type(1):before {*/
        /*content: "ลำดับ";*/
    /*}*/
    /*td:nth-of-type(2):before {*/
        /*content: "รหัสสินค้า";*/
    /*}*/
    /*td:nth-of-type(3):before {*/
        /*content: "ชื่อสินค้า";*/
    /*}*/
    /*td:nth-of-type(4):before {*/
        /*content: "จำนวน";*/
    /*}*/
</style>
